import React from 'react';
import { fontFamilies, fonts } from '../../../glassConsts';
import { useConfig } from '../../ConfigContext';

export default function FontPicker() {
  const { general, setGeneralState } = useConfig();

  return (
    <div>
      <label className="custom-label">Písmo textů</label>
      <div className="font-select">
        {fonts.map((f, i) => (
          <button
            className={`${i === 0 ? 'rounded-l-lg' : ''} ${i === 3 ? 'rounded-r-lg' : ''} px-5 py-2 border border-gray-300 ${general.font === f.name ? 'selected-font' : ''}`}
            style={{ fontFamily: fontFamilies[f.name] }}
            key={f.name}
            value={f.name}
            onClick={() => setGeneralState({ font: f.name })}
          >
            Písmo
          </button>
        ))}
      </div>
    </div>
  );
}
